import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=80c57a76&scoped=true&"
import script from "./Social.vue?vue&type=script&lang=ts&"
export * from "./Social.vue?vue&type=script&lang=ts&"
import style0 from "./Social.vue?vue&type=style&index=0&id=80c57a76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c57a76",
  null
  
)

export default component.exports